import { render, staticRenderFns } from "./text-porperty.vue?vue&type=template&id=6b5df7b5&scoped=true&"
import script from "./text-porperty.vue?vue&type=script&lang=js&"
export * from "./text-porperty.vue?vue&type=script&lang=js&"
import style0 from "./text-porperty.vue?vue&type=style&index=0&id=6b5df7b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5df7b5",
  null
  
)

export default component.exports